import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface MemberRequest {
    m_name: string;
    m_mobile: string;
    m_email: string;
    m_memo: string;
    m_password: string;
    customer_idx: number | null;
    customer_name: string | undefined;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutMember = (
    successCallback?: () => void,
    memberId?: string,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, MemberRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, AxiosError<ApiErrorResponse>, MemberRequest>({
        mutationFn: async (memberData: MemberRequest) => {
            try {
                const response = await axios.put(`${enum_api_uri.put_member}/${memberId}`, memberData, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getMemberList"] });
            successCallback?.();
        },
    });
};
